export const isValueContainArrayElementPart = (array: string[], value: string): boolean => {
  return array.filter((element) => value.indexOf(element) > -1).length > 0;
};
